import { $ } from "js/vendor";
import { app } from "js/namespaces";
import React from "react";
import ReactDOM from "react-dom";
import { Provider as ReduxProvider } from "react-redux";
import { MuiThemeProvider } from "@material-ui/core/styles";
import theme, { dialogTheme } from "./materialThemeOverrides";
import createStore from "./redux/createStore";
import addReactNDevTools from "reactn-devtools";
import { UNSAFE_GoogleAuthProvider } from "js/react/views/Auth/GoogleAuthContext";
import { UNSAFE_FirebaseAuthProvider } from "js/react/views/Auth/FirebaseAuthContext";
import { UNSAFE_FirebaseUserProvider } from "js/react/views/Auth/FirebaseUserContext";

addReactNDevTools();

export const store = createStore();

export const removeReactRoot = function(element) {
    ReactDOM.unmountComponentAtNode(element);
};

// React's Context is not available in ad-hoc ReactDOM.render roots, so we grab global auth,
// assuming that it was safely initalized elsewhere already
function provideAuth(children) {
    return (
        <UNSAFE_GoogleAuthProvider>
            <UNSAFE_FirebaseAuthProvider>
                <UNSAFE_FirebaseUserProvider>
                    {children}
                </UNSAFE_FirebaseUserProvider>
            </UNSAFE_FirebaseAuthProvider>
        </UNSAFE_GoogleAuthProvider>
    );
}

export default function renderReactRoot(Component, props = {}, element, theming = theme) {
    ReactDOM.render(
        provideAuth(
            <ReduxProvider store={store}>
                <MuiThemeProvider theme={theming}>
                    <Component {...props} />
                </MuiThemeProvider>
            </ReduxProvider>
        ),
        element
    );

    return () => {
        ReactDOM.unmountComponentAtNode(element);
    };
}

export function renderReactDialog(Component, props = {}, onClose) {
    let $dialogContainer = $("body").addEl($.div("dialog-container"));
    $dialogContainer.attr("dialog-container");

    let isShowingVerificationBanner = false;
    if (app && app.user) {
        isShowingVerificationBanner = app.mainView && app.mainView.shouldRenderVerificationBanner(app.user.getAuthUser());
    }

    if (isShowingVerificationBanner) {
        $dialogContainer.addClass("verify-email");
    }

    let unmount = () => {
        if (app && app.dialogManager) {
            app.dialogManager.openDialogs.remove(dialog);
        }
        ReactDOM.unmountComponentAtNode($dialogContainer[0]);
        $dialogContainer.remove();
        onClose && onClose();
    };

    props.closeDialog = unmount;

    let dialog = ReactDOM.render(
        provideAuth(
            <MuiThemeProvider theme={dialogTheme}>
                <Component {...props} closeDialog={unmount}/>
            </MuiThemeProvider>
        ),
        $dialogContainer[0]
    );

    if (app && app.dialogManager) {
        app.dialogManager.openDialogs.push(dialog);
    }

    return unmount;
}

export function renderReactDialogFromJSX(jsx, props = {}) {
    let $dialogContainer = $("body").addEl($.div("dialog-container"));
    $dialogContainer.attr("dialog-container");

    let unmount = () => {
        if (app && app.dialogManager) {
            app.dialogManager.openDialogs.remove(dialog);
        }
        ReactDOM.unmountComponentAtNode($dialogContainer[0]);
        $dialogContainer.remove();
    };

    let dialog = ReactDOM.render(
        provideAuth(
            <MuiThemeProvider theme={dialogTheme}>
                {jsx}
            </MuiThemeProvider>
        )
        , $dialogContainer[0]);

    if (app && app.dialogManager) {
        app.dialogManager.openDialogs.push(dialog);
    }

    return unmount;
}
